import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import { useEffect, useState } from "react";
import {
  RiCloseLine,
  RiCustomerService2Line,
  RiKakaoTalkFill,
} from "react-icons/ri";
import channelTalkLogo from "../../images/image144-Photoroom.png";
import { kakaoChannel } from "../utils/kakaoChannel";

export const FloatChatButton = ({
  channelMessengerOpen = false,
  setChannelMessengerOpen = () => {},
  userInfo,
}) => {
  const [open, setOpen] = useState(false);

  const isBrand = userInfo?.user_info?.user_type === "brand";

  useEffect(() => {
    if (!channelMessengerOpen) {
      setOpen(false);
    }
  }, [channelMessengerOpen]);

  if (channelMessengerOpen) return null;

  if (!isBrand) return null;

  return (
    <div className="absolute bottom-[24px] right-[24px] z-[999999] flex flex-col items-end gap-3">
      {open && (
        <>
          <button
            type="button"
            className="w-[56px] h-[56px] rounded-[24px] bg-[#FEE500] text-[#3C1F1E] flex items-center justify-center border-0 shadow-md float-chat-fab-in"
            onClick={() => {
              kakaoChannel();
              setOpen(false);
            }}
            aria-label="카카오톡 채널 채팅 열기"
          >
            <RiKakaoTalkFill size={30} />
          </button>

          <button
            type="button"
            className="w-[56px] h-[56px] rounded-[24px] bg-gradient-to-b from-[#F9A03F] to-[#F9BB3E] text-white flex items-center justify-center border-0 shadow-md float-chat-fab-in"
            onClick={() => {
              ChannelService.showMessenger();
              setOpen(false);
              setChannelMessengerOpen(true);
            }}
            aria-label="채널톡 열기"
          >
            <img
              src={channelTalkLogo}
              alt=""
              className="pointer-events-none h-[30px] w-[30px] object-contain"
            />
          </button>
        </>
      )}

      <button
        type="button"
        className={`w-[56px] h-[56px] rounded-[24px] flex items-center justify-center border-0 shadow-[0_8px_20px_rgba(0,0,0,0.15)] ${
          open
            ? "bg-white text-[#4A4A4A]"
            : "bg-gradient-to-br from-[#000000] to-[#606060] text-white"
        }`}
        onClick={() => setOpen(!open)}
        aria-label={open ? "상담 메뉴 닫기" : "상담 메뉴 열기"}
      >
        {open ? (
          <RiCloseLine size={30} aria-hidden className="text-[#4A4A4A]" />
        ) : (
          <RiCustomerService2Line size={30} aria-hidden />
        )}
      </button>
    </div>
  );
};
